<script lang="ts" setup>
import {useLayoutsStore} from "@/composables/layouts";
const layoutStore = useLayoutsStore();
layoutStore.changeLayout('empty')
</script>

<template>
  <div class="vh-100 w-100 d-flex justify-content-center align-items-center">
    <span class="h4 text-center">У вас нет доступа для работы в приложении.</span>
  </div>
</template>